import React from 'react';
import logo from '../../assets/images/logo-white.png';
import NavSocials from '../Navs/NavSocials';

function Footer() {
    return (
        <footer className="footer" style={{ position: 'relative', width: '100%' }}>
            <div className="footer--wrapper">
                <div className="container">
                    <div className="footer--header">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="footer--logo">
                                    <a href="index.html">
                                        <img src={logo} alt="footer" width="150px" height="auto" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-1">
                                <div className="footer--paragraph">
                                    <h3 className="heading heading-large light-1 footer--facility-statement">
                                        Dr. Mohammed Audu Rehab Centre is a professional rehabilitation facility in Nigeria dedicated to helping individuals recover from substance use disorders and related behavioral challenges through structured, ethical, and medically supervised care.
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer--details">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="detail-single footer-phone-number">
                                    <h6>PHONE</h6>
                                    <a href="tel:+23409131252197">
                                        <h4>(+234) 09131252197</h4>
                                    </a>
                                </div>
                                <div className="detail-single footer-address">
                                    <h6>ADDRESS</h6>
                                    <h4>Ado Kasa Karu Local Government Area Nasarawa State.</h4>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="detail-single footer-email">
                                    <h6>EMAIL</h6>
                                    <h4>info@dmarehab.org</h4>
                                </div>
                                <div className="detail-single">
                                    <NavSocials />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="detail-single">
                                    <ul className="footer--menu-links" style={{ listStyle: 'none', padding: 0 }}>
                                        <li><a href="/home" className="light-1">Home</a></li>
                                        <li><a href="/about" className="light-1">About Us</a></li>
                                        <li><a href="/programs" className="light-1">Our Programs</a></li>
                                        <li><a href="/admissions" className="light-1">Admissions</a></li>
                                        <li><a href="/facility" className="light-1">Our Facility</a></li>
                                        <li><a href="/impact" className="light-1">Impact</a></li>
                                        <li><a href="/activities" className="light-1">Activities</a></li>
                                        <li><a href="/contact" className="light-1">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <h6>© 2026 Dr. Mohammed Audu Rehab Centre. All rights reserved.<br />Made by <a href="https://www.myllash.com" target="_blank" rel="noopener" style={{color: 'white'}}>Myllash</a></h6>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
